import React from "react";
import LayoutClasses from "./Layout.module.css";
import SideNav from "../Navbar/sideNav";
import useStore from "../../store";

import TopNav from "../Navbar/topNav";
function Layout({ children, Active }) {
    const showNav = useStore((state) => state.showNavbar);
    const setShowNav = useStore((State) => State.setshowNavbar);
    return (
        <div className={LayoutClasses["Wrapper"]}>
            <SideNav Active={Active} setShow={setShowNav} show={showNav} />

            <div
                className={`${LayoutClasses["main-content"]} ${
                    !showNav ? LayoutClasses["nav-hide"] : ""
                }`}>
                <TopNav />
                <div style={{ zIndex: "2" }}>{children}</div>
            </div>
        </div>
    );
}

export default Layout;
